"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "aspect-3/2" };
const _hoisted_3 = ["src", "srcset", "alt"];
const _hoisted_4 = { class: "bg-mutedpurple-800 relative mb-5 p-3" };
const _hoisted_5 = { class: "bg-red py-3 px-4 absolute left-0 bottom-0 flex flex-col justify-center" };
const _hoisted_6 = { class: "font-black text-white text-center text-[42px] leading-none mb-1" };
const _hoisted_7 = { class: "font-semibold text-white text-center uppercase tracking-wider leading-none" };
const _hoisted_8 = {
    key: 0,
    class: "text-white text-right uppercase tracking-wider font-semibold whitespace-nowrap overflow-hidden text-ellipsis pl-20"
};
const _hoisted_9 = { class: "uppercase leading-squished tracking-tight font-black text-[32px] mb-3" };
const _hoisted_10 = { class: "uppercase font-semibold tracking-wider mb-5" };
const _hoisted_11 = { class: "flex items-center" };
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "font-semibold" }, "More Info", -1);
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
const format_1 = __importDefault(require("date-fns/format"));
const SvgSprite_vue_1 = __importDefault(require("../SvgSprite.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListingPreviewGrid',
    props: {
        listing: null
    },
    setup(__props) {
        const props = __props;
        let time = null;
        if (props.listing.start_time) {
            const timeArray = props.listing.start_time.split(":");
            time = `${timeArray[0]}:${timeArray[1]}`;
        }
        let day;
        let month;
        if (props.listing.start_date) {
            const start_date = (0, parseISO_1.default)(props.listing.start_date);
            day = (0, format_1.default)(start_date, 'd');
            month = (0, format_1.default)(start_date, 'MMM');
        }
        const categoriesString = props.listing.categories.map((cat) => cat.name).join(', ');
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("article", null, [
                (0, vue_2.createElementVNode)("a", {
                    href: __props.listing.url,
                    class: "block"
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (__props.listing.image)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                key: 0,
                                src: __props.listing.image.urls.size_3_2_360,
                                srcset: `${__props.listing.image.urls.size_3_2_360} 360w, ${__props.listing.image.urls.size_3_2_720} 720w, `,
                                sizes: "(max-width: 767px) 100vw, 330px",
                                alt: __props.listing.image.alt_text,
                                class: "w-full"
                            }, null, 8, _hoisted_3))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(day)), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(month)), 1)
                        ]),
                        ((0, vue_2.unref)(time))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, (0, vue_2.toDisplayString)(__props.listing.type) + " At " + (0, vue_2.toDisplayString)((0, vue_2.unref)(time)), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("h3", _hoisted_9, (0, vue_2.toDisplayString)(__props.listing.title), 1),
                    (0, vue_2.createElementVNode)("p", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(categoriesString)), 1),
                    (0, vue_2.createElementVNode)("p", _hoisted_11, [
                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                            href: "icon-chevron-right",
                            class: "w-2 h-4 mr-2"
                        }),
                        _hoisted_12
                    ])
                ], 8, _hoisted_1)
            ]));
        };
    }
});
